import { DataLayer } from "@allwyn/utils/data-layer";

/* eslint-disable @typescript-eslint/naming-convention */
export const ResponsibleGamingAnalytics = {
    pushStartTestEvent: () => {
        DataLayer.push({
            event: "action.start.rgTest",
        });
    },
    pushFinishTestEvent: (count: number, responses: boolean[]) => {
        let eventProperty1 = "low";

        if (count >= 4) {
            eventProperty1 = "high";
        } else if (count === 0) {
            eventProperty1 = "none";
        }

        DataLayer.push({
            event: "action.finish.rgTest",
            action: {
                finish: {
                    label: count.toString(),
                    eventProperty1,
                    eventProperty2: responses.map((response, index) => `${index + 1}${response ? "Y" : "N"}`).join(" "),
                },
            },
        });
    },
};
